



















































































































import { defineComponent, reactive, toRefs, onMounted, watch } from '@vue/composition-api';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { PracticeSumupResultDispSetting } from "../../modules/teacher/PracticeSumupResultDispEdit"

export interface Data {
  sumup_group_id: string
  sumup_group: any
  sections: PracticeSumupResultDispSetting[]
  columns: PracticeSumupResultDispSetting[]
  assets: PracticeSumupResultDispSetting[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: null,
      sumup_group: null,
      sections: [],
      columns: [],
      assets: [],
      errors: [],
    });

    const update = async () => {

      if(state.sections.filter(x => !x.label_text).length > 0){
        state.errors.push("表示セクションの表示テキストが未入力です。");
      }

      if(state.columns.filter(x => !x.label_text).length > 0){
        state.errors.push("表示項目の表示テキストが未入力です。");
      }

      if(state.assets.filter(x => !x.label_text).length > 0){
        state.errors.push("配布資料デフォルト表示の表示テキストが未入力です。");
      }

      if(state.errors.length > 0){
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }

      if(!window.confirm("表示設定を更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param = {
        settings: state.sections.concat(state.columns).concat(state.assets),
      }

      await http.post(`/api/teacher/practice_sumup_result_disp_edit/update/${state.sumup_group_id}`, param).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      
      await http.get(`/api/teacher/practice_sumup_result_disp_edit?sumup_group_id=${state.sumup_group_id}`).then(response => {
        state.sumup_group = response.data.sumup_group;
        state.sections = response.data.sections;
        state.columns = response.data.columns;
        state.assets = response.data.assets;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`処理に失敗しました。一覧に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      update
    }
  }
});
